<div
  *ngIf="colVm.columnType === Types.SectionColumnProductInfoType.StrainType"
  class="product-column-general product-strain-type"
  [ngClass]="rowVm | sectionRowViewModelBasicMethod: 'getReadableStrainType' : colVm.strainTypeMode | lowercase"
  [style.visibility]="section?.collapseContent || rowVm.collapseContent ? 'collapse' : ''"
  [style.text-decoration]="productStylingVm | forcedColumnTextDecoration: colVm : locConfig | async"
  [style.margin-right]="menu | productMenuBasicMethod: 'getSectionBorderMarginSize'">
  <app-handle-badge-mode
    [colVm]="colVm"
    [rowVm]="rowVm"
    [nonListColumnBadgeAsset]="this | method: 'getNonListColumnItem'">
    <ng-container *ngIf="useNgContent"><ng-content></ng-content></ng-container>
    <ng-container *ngIf="!useNgContent">{{ this | method: 'getNonListColumnItem' }}</ng-container>
  </app-handle-badge-mode>
</div>
